import Carousel from '../components/Carousel'
import Banner from '../components/Banner'
import { discountVoucherHref, tripDotComHref, apMTradingHref, exchangeHref, irisHref } from '../constants/href';
import { horizontalbarImage } from '../assets/images';

function HorizontalBarCarousel() {
  const adBannerArray = [
    <Banner key={discountVoucherHref.name} gaPage='Horizontal Bar' name={discountVoucherHref.name} eventHref={discountVoucherHref.href} image={horizontalbarImage.discountVoucherHorizontal}/>
  ]
  
  const shuffledBanner = adBannerArray.sort(() => Math.random() - 0.5);

  return (
    <Carousel bannerSize='horizontal-bar' gaPage='Horizontal Bar'>
      { shuffledBanner }
      <Banner key={irisHref.name} gaPage='Horizontal Bar' name={irisHref.name} eventHref={irisHref.href} image={horizontalbarImage.irisHorizontal}/>
      <Banner key={apMTradingHref.name} gaPage='Horizontal Bar' name={apMTradingHref.name} eventHref={apMTradingHref.href} image={horizontalbarImage.apMTradingHorizontal}/>
      <Banner key={exchangeHref.name} gaPage='Horizontal Bar' name={exchangeHref.name} eventHref={exchangeHref.href} image={horizontalbarImage.exchangeHorizontal}/>
      <Banner key={tripDotComHref.name} gaPage='Horizontal Bar' name={tripDotComHref.name} eventHref={tripDotComHref.href} image={horizontalbarImage.tripDotComHorizontal}/>
    </Carousel>
  )
}

export default HorizontalBarCarousel;
